const inr = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2, minimumFractionDigits: 2 });
const inr0 = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 });
const num = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 3 });

export const formatINR = (n, decimals = 2) => (decimals === 0 ? inr0 : inr).format(Number(n) || 0);
export const formatNum = (n) => num.format(Number(n) || 0);
export const formatPct = (n) => `${(Number(n) || 0).toFixed(2)}%`;

export function formatCompact(n) {
  const v = Number(n) || 0;
  const a = Math.abs(v);
  const sign = v < 0 ? "-" : "";
  if (a >= 1e7) return `${sign}₹${(a / 1e7).toFixed(2)} Cr`;
  if (a >= 1e5) return `${sign}₹${(a / 1e5).toFixed(2)} L`;
  return formatINR(v, 0);
}
